// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"3e789422","950":"101cb000"}[chunkId] + ".chunk.js";
};